module.exports = __webpack_public_path__ + "img/anxiety-icon-4.679d1e9a.svg";